import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import urlCheck from '../../utils/urlCheck';
import styles from './Breadcrumb.css';

/**
 * This component is responsible for the breadcrumbs at the top of the fund research portion of the site to make navigation easier.
 * (e.g. Home/Funds/Mutual Funds/Mutual Fund Research Tool)
 * It allows users to know where are the site they are and links to back to other parts of the site.
 * There are two categories of funds: Mutual Funds and ETFs
 *
 * @param {Object} props Used to provide information for the showScreenLink, name, and isWatchListView consts in the Breadcrumb when it is called
 *
 * @const {boolean} showScreenLink Retrieved from props and is used to determine whether or not to include the "[category] Research Tool" link in the breadcrumb
 * @const {String} name Retrieved from props and is the name of the part of the site the user is looking at and is what's displayed at the end of the breadcrumb with no link (as the user is already there)
 * @const {boolean} isWatchListView Retrieved from props and is used to add a class to the outer <div> that is returned
 * @const {boolean} isETFsPage Determined by the https link of the page and is used to determine whether this page falls under ETF or Mutual Funds
 *
 * @returns {html} Html code for the breadcrumb
 */
const Breadcrumb = (props) => {
    if (urlCheck('mobile')) {
        return (
            <>
                {/* spacer to make up for the breadcrumb being removed  */}
                <div style={{ height: '36px' }} />
            </>
        );
    }

    const { showScreenLink, name, etfName, isWatchlistView } = props;

    const isETFsPage = window.location.pathname.match(/etf/g);

    return (
        <div
            className={cn('breadcrumbs', {
                'watchlist-breadcrumbs': isWatchlistView
            })}
        >
            <div data-metrics-location="BRD">
                <a href="https://www.troweprice.com/personal-investing/home.html">
                    Home
                </a>
                <span> / </span>
                <a href="https://www.troweprice.com/personal-investing/funds/index.html">
                    Funds
                </a>
                <span> / </span>
                {!isETFsPage && (
                    <a href="https://www.troweprice.com/personal-investing/funds/mutual-funds/index.html">
                        Mutual Funds
                    </a>
                )}
                {isETFsPage && (
                    <a href="http://www.troweprice.com/personal-investing/funds/etfs/index.html">
                        ETFs
                    </a>
                )}
                {!isETFsPage &&
                    showScreenLink && (
                        <React.Fragment>
                            <span> / </span>
                            <NavLink
                                style={{
                                    color: '#898989',
                                    fontSize: '12px',
                                    textDecoration: 'none'
                                }}
                                exact
                                to="/"
                            >
                                Mutual Fund Research Tool
                            </NavLink>
                        </React.Fragment>
                    )}
                {isETFsPage &&
                    showScreenLink && (
                        <React.Fragment>
                            <span> / </span>
                            <NavLink
                                style={{
                                    color: '#898989',
                                    fontSize: '12px',
                                    textDecoration: 'none'
                                }}
                                exact
                                to="/etf"
                            >
                                ETF Research Tool
                            </NavLink>
                        </React.Fragment>
                    )}
                {name && (
                    <span className="destination">
                        <span> / </span>
                        {isETFsPage ? etfName : name}
                    </span>
                )}
            </div>
            <style jsx>{styles}</style>
        </div>
    );
};

export default Breadcrumb;
